import _ from 'lodash';
import moment from 'moment';

export function aggregateByStudent(data) {
  var outputObj = [];
  const attribs = ['assessments', 'homework', 'lessons', 'remedials'];
  Object.entries(data.students).forEach(([studentId, studentObj]) => {
    var studentOutObj = {
      totalCallTime: [],
      totalNumDoubts: 0,
      numItemsAttempted: 0,
      itemsAttemptedCorrectly: [],
      accuracy: [],
      numPresent: 0,
      numAbsent: 0,
      numTeacherAbsent: 0,
      timeOnWorksheets: [],
      chapterInfo: studentObj.chapter_info,
      analyticsLink:
        'https://leap-teacher.cuemath.com/student-profile/' + studentId + '/analytics',
      id: studentId,
      name: studentObj['first_name'] + ' ' + studentObj['last_name'],
      phone: studentObj['phone'],
      email: studentObj['email'],
      examDetails: studentObj['exam_details'],
      teacherRemarks: studentObj['teacher_remarks'],
      current_program: studentObj['current_program'],
      progress: {},
      ratings: {
        ratingVals: [],
        posFeedback: {},
        negFeedback: {},
      },
    };
    var oldDtJoined;
    studentObj.progress
      .sort((a, b) => (a.dt_joined < b.dt_joined ? 1 : -1))
      .forEach(prg => {
        studentOutObj['progress'][prg.program_code] = {};
        studentOutObj['progress'][prg.program_code]['dtJoined'] = prg.dt_joined;
        if (oldDtJoined) {
          studentOutObj['progress'][prg.program_code]['dtCompleted'] = oldDtJoined.split(
            ' ',
          )[0];
        } else {
          studentOutObj['progress'][prg.program_code]['dtCompleted'] = moment(
            new Date().toString(),
          ).format('YYYY-MM-DD');
        }
        oldDtJoined = prg.dt_joined;
        studentOutObj['progress'][prg.program_code]['chapterData'] = {
          offset: [],
          x: [],
          y: [],
          score: [],
        };
        prg.chapters_attempted
          .sort((a, b) => (a.chapter_position > b.chapter_position ? 1 : -1))
          .forEach(chp => {
            studentOutObj['progress'][prg.program_code]['chapterData']['offset'].push(
              chp.started_on,
            );
            studentOutObj['progress'][prg.program_code]['chapterData']['x'].push(
              chp.completed_on,
            );
            studentOutObj['progress'][prg.program_code]['chapterData']['y'].push(
              textTruncate(chp.chapter_name, 19),
            );
            let blockScore = 0.0;
            let blockMaxScore = 0.0;
            let chapterScore = 0.0;
            let chapterMaxScore = 0.0;
            var score;
            var chpAssessments = studentObj.assessments.filter(
              assmnt =>
                assmnt.chapter_id === chp.chapter_id &&
                assmnt.unlock_status &&
                assmnt.complete_status,
            );
            var chpAssessmentsAvailable = studentObj.assessments.filter(
              assmnt => assmnt.chapter_id === chp.chapter_id,
            );
            chpAssessments.forEach(assmnt => {
              var max_score = 0.0;
              var high_score = 0.0;
              assmnt.sessions_attempted.forEach(ssn => {
                if (ssn.score > high_score) {
                  high_score = ssn.score;
                  max_score = ssn.max_score;
                }
              });
              if (assmnt.node_type === 'BLOCK_ASSESSMENT') {
                blockScore += high_score;
                blockMaxScore += max_score;
              } else if (assmnt.node_type === 'CHAPTER_ASSESSMENT') {
                chapterScore += high_score;
                chapterMaxScore += max_score;
              }
            });
            if (!chp.completed_on) {
              score = -2.0; //Chapter In Progress
            } else if (chpAssessmentsAvailable.length === 0) {
              score = -1.0; //Assessments Unavailable
            } else {
              if (blockMaxScore !== 0 && chapterMaxScore !== 0) {
                score =
                  0.5 * (blockScore / blockMaxScore) +
                  0.5 * (chapterScore / chapterMaxScore);
              } else if (chapterMaxScore !== 0) {
                score = chapterScore / chapterMaxScore;
              } else {
                score = -3.0; //Assessment Pending.
              }
            }
            studentOutObj['progress'][prg.program_code]['chapterData']['score'].push(
              score,
            );
          });
      });
    attribs.forEach(attr => {
      //Count No. of Worksheets: #Unlocked, #Completed
      studentOutObj[attr] = {
        numUnlocked: 0,
        numCompleted: 0,
        accuracyList: [],
        tmTaken: 0,
      };
      studentObj[attr].forEach(wsSummary => {
        if (wsSummary.unlock_status) {
          studentOutObj[attr].numUnlocked += 1;
        }
        if (wsSummary.complete_status) {
          studentOutObj[attr].numCompleted += 1;
        }
        if (wsSummary.sessions_attempted.length !== 0) {
          var accuracy;
          var time = 0.0;
          wsSummary.sessions_attempted.forEach(ssn => {
            if (
              (accuracy && parseFloat(ssn.score) / ssn.max_score > accuracy) ||
              !accuracy
            ) {
              accuracy = parseFloat(ssn.score) / ssn.max_score;
            }
            time += ssn.time_spent / 60.0;
          });
          studentOutObj[attr]['tmTaken'] += time;
          studentOutObj[attr]['accuracyList'].push(accuracy);
        }
      });
      let nonNaAccuracy = studentOutObj[attr]['accuracyList'].filter(acc =>
        acc ? true : false,
      );
      studentOutObj[attr]['meanAccuracy'] = _.sum(nonNaAccuracy) / nonNaAccuracy.length;
    });
    var classrooms = data.classrooms.filter(clsrm => clsrm.student_id === studentId);
    if (classrooms.length > 0) {
      classrooms.forEach(cls => {
        var scoreToday = 0;
        var maxScoreToday = 0;
        var itemsAttempted = 0;
        var timeOnWorksheets = 0;
        var itemsAttemptedCorrectly = 0.0;
        Object.values(cls.sessions_attempted).forEach(ssn => {
          itemsAttempted += ssn.num_attempted_today;
          itemsAttemptedCorrectly +=
            parseFloat(ssn.num_attempted_today * ssn.score) / ssn.max_score;
          timeOnWorksheets += ssn.time_spent;
          scoreToday += ssn.score;
          maxScoreToday += ssn.max_score;
        });
        studentOutObj['totalNumDoubts'] += cls.num_doubt_button_presses;
        studentOutObj['numItemsAttempted'] += itemsAttempted;
        if (maxScoreToday !== 0) {
          let accuracy = parseFloat(scoreToday) / maxScoreToday;
          studentOutObj['accuracy'].push(accuracy);
          studentOutObj['itemsAttemptedCorrectly'].push(itemsAttemptedCorrectly);
        }
        studentOutObj['timeOnWorksheets'].push(timeOnWorksheets);
        studentOutObj['totalCallTime'].push(cls.total_call_duration);
        if (cls.status === 'P' && Object.keys(cls.sessions_attempted).length !== 0) {
          studentOutObj['numPresent'] += 1;
        } else if (cls.status === 'A') {
          studentOutObj['numAbsent'] += 1;
        } else if (cls.status === 'TA') {
          studentOutObj['numTeacherAbsent'] += 1;
        }
        if (cls.ratings) {
          // console.log('ERROR HERE', cls.ratings);
          if (!cls.ratings.rating) {
            console.log('What does it mean', cls.ratings);
          }
          if (cls.ratings.rating) {
            studentOutObj['ratings']['ratingVals'].push(cls.ratings.rating);
          }
          let feedbackObj = JSON.parse(cls.ratings.meta);
          if (feedbackObj.feedback_tags) {
            if (cls.ratings.rating >= 5) {
              feedbackObj.feedback_tags.forEach(tg => {
                if (studentOutObj['ratings']['posFeedback'][tg]) {
                  studentOutObj['ratings']['posFeedback'][tg] += 1;
                } else {
                  studentOutObj['ratings']['posFeedback'][tg] = 1;
                }
              });
            } else {
              feedbackObj.feedback_tags.forEach(tg => {
                if (studentOutObj['ratings']['negFeedback'][tg]) {
                  studentOutObj['ratings']['negFeedback'][tg] += 1;
                } else {
                  studentOutObj['ratings']['negFeedback'][tg] = 1;
                }
              });
            }
          }
        }
      });
    }
    outputObj.push(studentOutObj);
  });
  return outputObj;
}

export function splitArray(left, right, parts) {
  var result = [],
    delta = (right - left) / (parts - 1);
  while (left < right) {
    result.push(left);
    left += delta;
  }
  result.push(right);
  return result;
}

export function textTruncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = '...';
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

export function getProgramColor(program, currentProgram) {
  if (program.includes('IMO') || program.includes('MathAccel')) {
    return 'yellow';
  } else if (currentProgram !== program) {
    return 'black';
  } else {
    return 'green';
  }
}
